export enum PATH {
    HOME = '',
    PROFILE = 'profile',
    VISITORS = 'visitors',
    MEMBERSHIPS = 'memberships',
    MONITORING = 'monitoring',
    ADMINISTRATION = 'administration',
    ENTITIES = 'entities',
    PAYMENTS = 'payments',
    STATISTICS = 'statistics',
    VALIDATIONS = 'validations',
    JOIN_PARKING = 'join',
}
